import { createContext, useContext } from "react";

interface VisibleNutrientsIf {
  nutrients: string[];
  setNutrients: (nutrients: string[]) => void;
}

export const VisibleNutrientsContext = createContext<VisibleNutrientsIf>({
  nutrients: [],
  setNutrients: () => null,
});

export function useVisibleNutrients() {
  return useContext(VisibleNutrientsContext);
}

export const visibleNutrientsKey = "visibleNutrients";
